import { ITableSettingsDrawerState } from "../table-settings.models";

export const filterManageColumnsData = (
  items: ITableSettingsDrawerState<object>,
  searchText: string | undefined,
): ITableSettingsDrawerState<object> => {
  if (!searchText?.trim()) {
    return items;
  }

  const searchTextToLowerCase = searchText.toLocaleLowerCase();

  const activeColumns = items.activeColumns?.filter(({ meta }) =>
    meta?.displayName?.toLocaleLowerCase()?.includes(searchTextToLowerCase),
  );

  const inactiveColumns = items.inactiveColumns?.filter(({ meta }) =>
    meta?.displayName?.toLocaleLowerCase()?.includes(searchTextToLowerCase),
  );

  return {
    activeColumns,
    inactiveColumns,
  };
};
